import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IndexComponent } from './index/index.component';
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { ZendeskDevelopmentComponent } from './zendesk-development/zendesk-development.component';

const aboutUsRoutes: Routes = [
  {
    path: 'about-us',
    component: IndexComponent,
    children:[
      { path: 'terms-of-use',  component: TermsOfUseComponent },
      { path: 'privacy-policy', component: PrivacyPolicyComponent },
      { path: 'zendesk-development', component: ZendeskDevelopmentComponent },
      {
        path: '',
        redirectTo: 'terms-of-use',
        pathMatch: 'full'
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(aboutUsRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class AboutUsRoutingModule { }
